<h2>{{ title }}</h2>
<div>
  @for (product of products; track product.id) {
    @if (product.forSale) {
      <app-product-card [product]="product" [small]="true"></app-product-card>
    }
  }
</div>
